import { getTenantId } from '../utils/tenant';
import { Api } from './client/Api';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';


export const getConfigId = (): string => {
  return localStorage.getItem('configId') || 'default';
};

// Function to update tenant header dynamically
export const updateTenantHeader = (tenantId: string) => {
  localStorage.setItem('tenant', tenantId);
};

// Function to update config ID header dynamically
export const updateConfigIdHeader = (configId: string) => {
  localStorage.setItem('configId', configId);
};

// Function to refresh API client headers
export const refreshApiClientHeaders = () => {
  // This will be called when headers need to be refreshed
  // The headers are read dynamically from localStorage in the baseApiParams
  console.log('API client headers refreshed');
};

const apiClient = new Api({
  baseUrl: API_BASE_URL,
  baseApiParams: {
    headers: {
      'Content-Type': 'application/json',
      'X-Manager-ID': 'tenant-web',
      'X-Tenant': getTenantId(),
    },
  },
});

export default apiClient;
